// // src/utils/firebaseUtils.js
// import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
// import { db } from "../firebase";

// // const CACHE_DURATION_MS = 4 * 60 * 60 * 1000; // 4 hours

// const CACHE_DURATION_MS = 2 * 60 * 60 * 1000; // 2 hours


// export const getCachedYoutubeData = async (channelId) => {
//   const ref = doc(db, "youtubeChannels", channelId);
//   const snap = await getDoc(ref);

//   if (!snap.exists()) return null;

//   const data = snap.data();
//   const lastFetched = data.lastFetchedAt?.toMillis?.();

//   if (!lastFetched) return null;

//   const isExpired = Date.now() - lastFetched > CACHE_DURATION_MS;

//   return isExpired ? null : data;
// };

// export const saveYoutubeData = async (channelId, payload) => {
//   const ref = doc(db, "youtubeChannels", channelId);
//   await setDoc(
//     ref,
//     {
//       ...payload,
//       lastFetchedAt: serverTimestamp()
//     },
//     { merge: true }
//   );
// };









// src/utils/firebaseUtils.js

import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp
} from "firebase/firestore";

import { db } from "../firebase";


// ============================================
// CACHE DURATION
// ============================================

// Cache duration: 2 hours
const CACHE_DURATION_MS = 2 * 60 * 60 * 1000;


// ============================================
// YOUTUBE
// ============================================

export const getCachedYoutubeData = async (channelId) => {

  try {

    const ref = doc(
      db,
      "youtubeChannels",
      channelId
    );

    const snap = await getDoc(ref);


    if (!snap.exists()) {
      return null;
    }


    const data = snap.data();

    const lastFetched =
      data.lastFetchedAt?.toMillis?.();


    if (!lastFetched) {
      return null;
    }


    const isExpired =
      Date.now() - lastFetched >
      CACHE_DURATION_MS;


    return isExpired ? null : data;

  } catch (error) {

    console.error(
      "Error getting cached YouTube data:",
      error
    );

    return null;
  }
};


export const saveYoutubeData = async (
  channelId,
  payload
) => {

  try {

    const ref = doc(
      db,
      "youtubeChannels",
      channelId
    );


    await setDoc(
      ref,
      {
        ...payload,

        lastFetchedAt:
          serverTimestamp()

      },
      {
        merge: true
      }
    );

  } catch (error) {

    console.error(
      "Error saving YouTube data:",
      error
    );

  }
};



// ============================================
// INSTAGRAM
// ============================================

export const getCachedInstagramData = async (
  username
) => {

  try {

    const ref = doc(
      db,
      "instagramAccounts",
      username
    );

    const snap = await getDoc(ref);


    if (!snap.exists()) {
      return null;
    }


    const data = snap.data();

    const lastFetched =
      data.lastFetchedAt?.toMillis?.();


    if (!lastFetched) {
      return null;
    }


    const isExpired =
      Date.now() - lastFetched >
      CACHE_DURATION_MS;


    return isExpired ? null : data;

  } catch (error) {

    console.error(
      "Error getting cached Instagram data:",
      error
    );

    return null;
  }
};


export const saveInstagramData = async (
  username,
  payload
) => {

  try {

    const ref = doc(
      db,
      "instagramAccounts",
      username
    );


    await setDoc(
      ref,
      {
        ...payload,

        lastFetchedAt:
          serverTimestamp()

      },
      {
        merge: true
      }
    );

  } catch (error) {

    console.error(
      "Error saving Instagram data:",
      error
    );

  }
};